<div>
    <div class="center">
        <app-paragraph></app-paragraph>
    </div>
    <app-reset-button></app-reset-button>
</div>